import { Alert, Button } from "@mui/material";
import { useAuthContext } from "src/auth/hooks";
import { useTranslate } from "src/locales";
import { useRouter, useSearchParams } from "src/routes/hooks";

export default function OfficeSourceNotice() {
  const query = useSearchParams();
  const router = useRouter();
  const { currentProvider } = useAuthContext();
  const { t } = useTranslate();
  const source = Number(query.get("office_source"));
  const kind = query.get("office_kind");
  if (!Number.isSafeInteger(source) || source <= 0 || !kind || !["registrations", "licences", "transfers", "documents", "entries", "medical", "finance", "integrations"].includes(kind)) return null;
  const sameOffice = Number(query.get("office_provider")) === Number(currentProvider);
  return <Alert severity={sameOffice ? "info" : "warning"} sx={{ mx: { xs: 2, md: 5 }, mb: 2 }} action={<Button onClick={() => router.replace(window.location.pathname)}>{t("office_state_all")}</Button>}>
    {sameOffice ? `${t(`office_${kind}`)} #${source}` : t("office_wrong_provider")}
  </Alert>;
}
